module.exports = __webpack_public_path__ + "media/06_juntos.2aebb5ce.mp3";